// Public Shopify snapshot. Prices are integer cents; options retain source order.
// Chrome went live 10/24 and Gold 10/31 at the Holographic prices (Josh 10/31 pricing audit: "Make them buyable").
// Josh 10/17: flat (Economical) Standard is two materials, Gloss and Matte (these labels have no laminate
// option). Gloss keeps the live Standard variant; Matte has its own live variant at the same price since 10/31.
window.VP_JAR_LABEL_DATA = {
  "sourceUrl": "https://vinylpac.us/pages/labels",
  "verifiedAt": "2026-09-07T02:45:07Z",
  "products": [
    {
      "id": "miron-5ml-ceres",
      "name": "Miron 5ml Ceres Jar Labels",
      "jarType": "Ceres",
      "handle": "miron-5ml-jar-labels-top-sticker-perforated-wrap",
      "url": "https://vinylpac.us/products/miron-5ml-jar-labels-top-sticker-perforated-wrap",
      "description": "Custom top sticker with perforated jar wrap, priced together, for Miron Ceres 5ml violet glass jars. Choose your print tier and finish. Holographic and glitter are offered as separate finishes. Embossing: the Economical tier is printed flat with no embossing. The Standard and Premium embossing tiers are raised/embossed and let you choose a gloss or matte emboss finish. Volume discounts apply automatically as you add more to your cart. Artwork & mapping layers: All orders must be submitted with print-ready artwork that includes a correctly configured mapping layer (dieline and placement guide) showing how your design aligns and wraps on the jar. If your files don't include an appropriate mapping layer, our design team will create one for you at $50/hour. This work is quoted separately and billed on a follow-up invoice, which must be paid in full before your job enters production.",
      "setDescription": "Top sticker + perforated jar wrap, priced as one set.",
      "images": [
        {
          "src": (window.VP_CDN+"jar-labels__stage__jl-ceres-wrap0.webp?v=6dc624e02c"),
          "alt": "Miron 5ml Ceres jar with the VINYLPAC sample top and wrap labels",
          "width": 1000,
          "height": 1000,
          "sample": true
        }
      ],
      "variants": [
        {
          "id": "47965438312606",
          "price": 70,
          "available": true,
          "options": [
            "Economical",
            "Gloss",
            "No Embossing"
          ]
        },
        {
          "id": "67894668296350",
          "price": 70,
          "available": true,
          "options": [
            "Economical",
            "Matte",
            "No Embossing"
          ]
        },
        {
          "id": "47965438345374",
          "price": 95,
          "available": true,
          "options": [
            "Economical",
            "Holographic",
            "No Embossing"
          ]
        },
        {
          "id": "67809325449374",
          "price": 95,
          "available": true,
          "options": [
            "Economical",
            "Chrome",
            "No Embossing"
          ]
        },
        {
          "id": "67894668132510",
          "price": 95,
          "available": true,
          "options": [
            "Economical",
            "Gold",
            "No Embossing"
          ]
        },
        {
          "id": "47965438378142",
          "price": 95,
          "available": true,
          "options": [
            "Economical",
            "Glitter",
            "No Embossing"
          ]
        },
        {
          "id": "47964526346398",
          "price": 110,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Standard",
            "Gloss"
          ]
        },
        {
          "id": "47965222502558",
          "price": 110,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Standard",
            "Matte"
          ]
        },
        {
          "id": "47965438410910",
          "price": 135,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Holographic",
            "Gloss"
          ]
        },
        {
          "id": "47965438443678",
          "price": 135,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Holographic",
            "Matte"
          ]
        },
        {
          "id": "67809325482142",
          "price": 135,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Chrome",
            "Gloss"
          ]
        },
        {
          "id": "67809325514910",
          "price": 135,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Chrome",
            "Matte"
          ]
        },
        {
          "id": "67894668165278",
          "price": 135,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Gold",
            "Gloss"
          ]
        },
        {
          "id": "67894668198046",
          "price": 135,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Gold",
            "Matte"
          ]
        },
        {
          "id": "47965438476446",
          "price": 135,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Glitter",
            "Gloss"
          ]
        },
        {
          "id": "47965438509214",
          "price": 135,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Glitter",
            "Matte"
          ]
        },
        {
          "id": "47964526411934",
          "price": 160,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Standard",
            "Gloss"
          ]
        },
        {
          "id": "47965222568094",
          "price": 160,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Standard",
            "Matte"
          ]
        },
        {
          "id": "47965438541982",
          "price": 185,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Holographic",
            "Gloss"
          ]
        },
        {
          "id": "47965438574750",
          "price": 185,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Holographic",
            "Matte"
          ]
        },
        {
          "id": "67809325547678",
          "price": 185,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Chrome",
            "Gloss"
          ]
        },
        {
          "id": "67809325580446",
          "price": 185,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Chrome",
            "Matte"
          ]
        },
        {
          "id": "67894668230814",
          "price": 185,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Gold",
            "Gloss"
          ]
        },
        {
          "id": "67894668263582",
          "price": 185,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Gold",
            "Matte"
          ]
        },
        {
          "id": "47965438607518",
          "price": 185,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Glitter",
            "Gloss"
          ]
        },
        {
          "id": "47965438640286",
          "price": 185,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Glitter",
            "Matte"
          ]
        }
      ]
    },
    {
      "id": "miron-5ml-eris",
      "name": "Miron 5ml Eris (Child Resistant Lid) Jar Labels",
      "jarType": "Eris",
      "handle": "miron-5ml-jar-labels-top-sticker-perforated-wrap",
      "url": "https://vinylpac.us/products/miron-5ml-jar-labels-top-sticker-perforated-wrap",
      "description": "Custom top sticker with perforated jar wrap, priced together, for Miron Eris 5ml violet glass jars with child-resistant lids. Choose your print tier and finish. Holographic and glitter are offered as separate finishes. Embossing: the Economical tier is printed flat with no embossing. The Standard and Premium embossing tiers are raised/embossed and let you choose a gloss or matte emboss finish. Volume discounts apply automatically as you add more to your cart. Artwork & mapping layers: All orders must be submitted with print-ready artwork that includes a correctly configured mapping layer (dieline and placement guide) showing how your design aligns and wraps on the jar. If your files don't include an appropriate mapping layer, our design team will create one for you at $50/hour. This work is quoted separately and billed on a follow-up invoice, which must be paid in full before your job enters production.",
      "setDescription": "Top sticker + perforated jar wrap, priced as one set.",
      "images": [
        {
          "src": (window.VP_CDN+"jar-labels__stage__jl-eris-wrap0.webp?v=2241cf24b5"),
          "alt": "Miron 5ml Eris jar with the VINYLPAC sample top and wrap labels",
          "width": 1000,
          "height": 1000,
          "sample": true
        }
      ],
      "variants": [
        {
          "id": "47965438312606",
          "price": 70,
          "available": true,
          "options": [
            "Economical",
            "Gloss",
            "No Embossing"
          ]
        },
        {
          "id": "67894668296350",
          "price": 70,
          "available": true,
          "options": [
            "Economical",
            "Matte",
            "No Embossing"
          ]
        },
        {
          "id": "47965438345374",
          "price": 95,
          "available": true,
          "options": [
            "Economical",
            "Holographic",
            "No Embossing"
          ]
        },
        {
          "id": "67809325449374",
          "price": 95,
          "available": true,
          "options": [
            "Economical",
            "Chrome",
            "No Embossing"
          ]
        },
        {
          "id": "67894668132510",
          "price": 95,
          "available": true,
          "options": [
            "Economical",
            "Gold",
            "No Embossing"
          ]
        },
        {
          "id": "47965438378142",
          "price": 95,
          "available": true,
          "options": [
            "Economical",
            "Glitter",
            "No Embossing"
          ]
        },
        {
          "id": "47964526346398",
          "price": 110,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Standard",
            "Gloss"
          ]
        },
        {
          "id": "47965222502558",
          "price": 110,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Standard",
            "Matte"
          ]
        },
        {
          "id": "47965438410910",
          "price": 135,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Holographic",
            "Gloss"
          ]
        },
        {
          "id": "47965438443678",
          "price": 135,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Holographic",
            "Matte"
          ]
        },
        {
          "id": "67809325482142",
          "price": 135,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Chrome",
            "Gloss"
          ]
        },
        {
          "id": "67809325514910",
          "price": 135,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Chrome",
            "Matte"
          ]
        },
        {
          "id": "67894668165278",
          "price": 135,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Gold",
            "Gloss"
          ]
        },
        {
          "id": "67894668198046",
          "price": 135,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Gold",
            "Matte"
          ]
        },
        {
          "id": "47965438476446",
          "price": 135,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Glitter",
            "Gloss"
          ]
        },
        {
          "id": "47965438509214",
          "price": 135,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Glitter",
            "Matte"
          ]
        },
        {
          "id": "47964526411934",
          "price": 160,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Standard",
            "Gloss"
          ]
        },
        {
          "id": "47965222568094",
          "price": 160,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Standard",
            "Matte"
          ]
        },
        {
          "id": "47965438541982",
          "price": 185,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Holographic",
            "Gloss"
          ]
        },
        {
          "id": "47965438574750",
          "price": 185,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Holographic",
            "Matte"
          ]
        },
        {
          "id": "67809325547678",
          "price": 185,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Chrome",
            "Gloss"
          ]
        },
        {
          "id": "67809325580446",
          "price": 185,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Chrome",
            "Matte"
          ]
        },
        {
          "id": "67894668230814",
          "price": 185,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Gold",
            "Gloss"
          ]
        },
        {
          "id": "67894668263582",
          "price": 185,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Gold",
            "Matte"
          ]
        },
        {
          "id": "47965438607518",
          "price": 185,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Glitter",
            "Gloss"
          ]
        },
        {
          "id": "47965438640286",
          "price": 185,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Glitter",
            "Matte"
          ]
        }
      ]
    },
    {
      "id": "black-4oz",
      "name": "4oz Jar Labels",
      "handle": "4oz-1-8-oz-jar-labels-top-sticker-jar-wrap",
      "url": "https://vinylpac.us/products/4oz-1-8-oz-jar-labels-top-sticker-jar-wrap",
      "description": "Custom top sticker and jar wrap, priced together, for 4oz (1/8 oz) straight-sided jars. Choose your print tier and finish. Holographic and glitter are offered as separate finishes. Embossing: the Economical tier is printed flat with no embossing. The Standard and Premium embossing tiers are raised/embossed and let you choose a gloss or matte emboss finish. Volume discounts apply automatically as you add more to your cart. Artwork & mapping layers: All orders must be submitted with print-ready artwork that includes a correctly configured mapping layer (dieline and placement guide) showing how your design aligns and wraps on the jar. If your files don't include an appropriate mapping layer, our design team will create one for you at $50/hour. This work is quoted separately and billed on a follow-up invoice, which must be paid in full before your job enters production.",
      "setDescription": "Top sticker + jar wrap, priced as one set.",
      "images": [
        {
          "src": (window.VP_CDN+"jar-labels__stage__jl-black4oz-wrap1.webp?v=d6f4b4598c"),
          "alt": "4oz black jar with the VINYLPAC sample top and wrap labels",
          "width": 1000,
          "height": 1000,
          "sample": true
        }
      ],
      "variants": [
        {
          "id": "47965434773662",
          "price": 85,
          "available": true,
          "options": [
            "Economical",
            "Gloss",
            "No Embossing"
          ]
        },
        {
          "id": "67894668492958",
          "price": 85,
          "available": true,
          "options": [
            "Economical",
            "Matte",
            "No Embossing"
          ]
        },
        {
          "id": "47965434806430",
          "price": 120,
          "available": true,
          "options": [
            "Economical",
            "Holographic",
            "No Embossing"
          ]
        },
        {
          "id": "67809324564638",
          "price": 120,
          "available": true,
          "options": [
            "Economical",
            "Chrome",
            "No Embossing"
          ]
        },
        {
          "id": "67894668329118",
          "price": 120,
          "available": true,
          "options": [
            "Economical",
            "Gold",
            "No Embossing"
          ]
        },
        {
          "id": "47965434839198",
          "price": 120,
          "available": true,
          "options": [
            "Economical",
            "Glitter",
            "No Embossing"
          ]
        },
        {
          "id": "47964501344414",
          "price": 125,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Standard",
            "Gloss"
          ]
        },
        {
          "id": "47965220012190",
          "price": 125,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Standard",
            "Matte"
          ]
        },
        {
          "id": "47965434871966",
          "price": 160,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Holographic",
            "Gloss"
          ]
        },
        {
          "id": "47965434904734",
          "price": 160,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Holographic",
            "Matte"
          ]
        },
        {
          "id": "67809324597406",
          "price": 160,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Chrome",
            "Gloss"
          ]
        },
        {
          "id": "67809324630174",
          "price": 160,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Chrome",
            "Matte"
          ]
        },
        {
          "id": "67894668361886",
          "price": 160,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Gold",
            "Gloss"
          ]
        },
        {
          "id": "67894668394654",
          "price": 160,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Gold",
            "Matte"
          ]
        },
        {
          "id": "47965434937502",
          "price": 160,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Glitter",
            "Gloss"
          ]
        },
        {
          "id": "47965434970270",
          "price": 160,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Glitter",
            "Matte"
          ]
        },
        {
          "id": "47964501409950",
          "price": 230,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Standard",
            "Gloss"
          ]
        },
        {
          "id": "47965220077726",
          "price": 230,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Standard",
            "Matte"
          ]
        },
        {
          "id": "47965435003038",
          "price": 265,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Holographic",
            "Gloss"
          ]
        },
        {
          "id": "47965435035806",
          "price": 265,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Holographic",
            "Matte"
          ]
        },
        {
          "id": "67809324662942",
          "price": 265,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Chrome",
            "Gloss"
          ]
        },
        {
          "id": "67809324695710",
          "price": 265,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Chrome",
            "Matte"
          ]
        },
        {
          "id": "67894668427422",
          "price": 265,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Gold",
            "Gloss"
          ]
        },
        {
          "id": "67894668460190",
          "price": 265,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Gold",
            "Matte"
          ]
        },
        {
          "id": "47965435068574",
          "price": 265,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Glitter",
            "Gloss"
          ]
        },
        {
          "id": "47965435101342",
          "price": 265,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Glitter",
            "Matte"
          ]
        }
      ]
    },
    {
      "id": "miron-150ml",
      "name": "Miron 150ml Jar Labels",
      "handle": "miron-150ml-jar-labels-top-sticker-jar-wrap",
      "url": "https://vinylpac.us/products/miron-150ml-jar-labels-top-sticker-jar-wrap",
      "description": "Custom top sticker and jar wrap, priced together, for Miron 150ml violet glass jars. Choose your print tier and finish. Holographic and glitter are offered as separate finishes. Embossing: the Economical tier is printed flat with no embossing. The Standard and Premium embossing tiers are raised/embossed and let you choose a gloss or matte emboss finish. Volume discounts apply automatically as you add more to your cart. Artwork & mapping layers: All orders must be submitted with print-ready artwork that includes a correctly configured mapping layer (dieline and placement guide) showing how your design aligns and wraps on the jar. If your files don't include an appropriate mapping layer, our design team will create one for you at $50/hour. This work is quoted separately and billed on a follow-up invoice, which must be paid in full before your job enters production.",
      "setDescription": "Top sticker + jar wrap, priced as one set.",
      "images": [
        {
          "src": (window.VP_CDN+"jar-labels__miron-150ml-vinylpac-lid-wrap.webp?v=1111a0fbb1"),
          "alt": "Miron 150ml jar with the VINYLPAC sample top, wrap and lid wrap labels",
          "width": 1000,
          "height": 1000,
          "sample": true,
          "lidWrap": true
        },
        {
          "src": (window.VP_CDN+"jar-labels__miron-150ml-vinylpac-no-lid-wrap.webp?v=5c637e1600"),
          "alt": "Miron 150ml jar with the VINYLPAC sample top and wrap labels",
          "width": 1000,
          "height": 1000,
          "sample": true,
          "lidWrap": false
        }
      ],
      "variants": [
        {
          "id": "47965442113694",
          "price": 100,
          "available": true,
          "options": [
            "Economical",
            "Gloss",
            "No Embossing"
          ]
        },
        {
          "id": "67894668689566",
          "price": 100,
          "available": true,
          "options": [
            "Economical",
            "Matte",
            "No Embossing"
          ]
        },
        {
          "id": "47965442146462",
          "price": 140,
          "available": true,
          "options": [
            "Economical",
            "Holographic",
            "No Embossing"
          ]
        },
        {
          "id": "67809322729630",
          "price": 140,
          "available": true,
          "options": [
            "Economical",
            "Chrome",
            "No Embossing"
          ]
        },
        {
          "id": "67894668525726",
          "price": 140,
          "available": true,
          "options": [
            "Economical",
            "Gold",
            "No Embossing"
          ]
        },
        {
          "id": "47965442179230",
          "price": 140,
          "available": true,
          "options": [
            "Economical",
            "Glitter",
            "No Embossing"
          ]
        },
        {
          "id": "47964572713118",
          "price": 150,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Standard",
            "Gloss"
          ]
        },
        {
          "id": "47965224304798",
          "price": 150,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Standard",
            "Matte"
          ]
        },
        {
          "id": "47965442211998",
          "price": 190,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Holographic",
            "Gloss"
          ]
        },
        {
          "id": "47965442244766",
          "price": 190,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Holographic",
            "Matte"
          ]
        },
        {
          "id": "67809322762398",
          "price": 190,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Chrome",
            "Gloss"
          ]
        },
        {
          "id": "67809322795166",
          "price": 190,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Chrome",
            "Matte"
          ]
        },
        {
          "id": "67894668558494",
          "price": 190,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Gold",
            "Gloss"
          ]
        },
        {
          "id": "67894668591262",
          "price": 190,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Gold",
            "Matte"
          ]
        },
        {
          "id": "47965442277534",
          "price": 190,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Glitter",
            "Gloss"
          ]
        },
        {
          "id": "47965442310302",
          "price": 190,
          "available": true,
          "options": [
            "Standard Tier Embossing",
            "Glitter",
            "Matte"
          ]
        },
        {
          "id": "47964572778654",
          "price": 260,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Standard",
            "Gloss"
          ]
        },
        {
          "id": "47965224370334",
          "price": 260,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Standard",
            "Matte"
          ]
        },
        {
          "id": "47965442343070",
          "price": 300,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Holographic",
            "Gloss"
          ]
        },
        {
          "id": "47965442375838",
          "price": 300,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Holographic",
            "Matte"
          ]
        },
        {
          "id": "67809322827934",
          "price": 300,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Chrome",
            "Gloss"
          ]
        },
        {
          "id": "67809322860702",
          "price": 300,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Chrome",
            "Matte"
          ]
        },
        {
          "id": "67894668624030",
          "price": 300,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Gold",
            "Gloss"
          ]
        },
        {
          "id": "67894668656798",
          "price": 300,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Gold",
            "Matte"
          ]
        },
        {
          "id": "47965442408606",
          "price": 300,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Glitter",
            "Gloss"
          ]
        },
        {
          "id": "47965442441374",
          "price": 300,
          "available": true,
          "options": [
            "Premium Tier Embossing",
            "Glitter",
            "Matte"
          ]
        }
      ]
    }
  ]
};
